import { NgModule } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { IdleSnackbarComponent } from '@app/shared/components/idle-snackbar/idle-snackbar.component';
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateModule } from '@ngx-translate/core';
import IdleService from '@services/idle.service';

@NgModule({
  declarations: [
    IdleSnackbarComponent
  ],
  imports: [
    NgIdleModule.forRoot(),
    NgIdleKeepaliveModule.forRoot(),
    MatSnackBarModule,
    MatProgressSpinnerModule,
    TranslateModule
  ],
  providers: [
    IdleService
  ]
})
export default class IdleModule {
}
